import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/arrow_left.svg
 */
const IconArrowLeft: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      opacity={0.9}
      d="M6.011 11.727c-.018.082-.03.165-.034.249.004.085.016.172.034.256.013.082.034.161.063.24.037.083.084.164.14.237.021.055.05.105.085.152l9.386 10.685a1.334 1.334 0 102.006-1.761l-8.61-9.81 8.61-9.799A1.337 1.337 0 0015.685.412L6.3 11.095a.677.677 0 00-.086.155 1.136 1.136 0 00-.14.235c-.028.078-.049.16-.062.242z"
      fill="currentColor"
    />
  </svg>
);

export default IconArrowLeft;
